<template>
  <div>
    <a-spin :spinning="loading">
      <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
    </a-spin>
    <div v-if="!loading">
      <a-card :bordered="false">
        <a-tabs type="card">
          <a-tab-pane key="1" tab="Basic" :forceRender="true">
            <hotel-basic></hotel-basic>
          </a-tab-pane>
          <a-tab-pane key="2" tab="Designer" :forceRender="true">
            <hotel-designer></hotel-designer>
          </a-tab-pane>
          <a-tab-pane key="3" tab="Warm Prompt" :forceRender="true">
            <hotel-prompt></hotel-prompt>
          </a-tab-pane>
        </a-tabs>
        </a-card>
    </div>
    <footer-tool-bar>
      <a-button type="primary" html-type="submit" :loading="saving" @click="handleSubmit">Save</a-button>
      <a-button style="margin-left: 8px;" :loading="saving" @click="handleGoBack">Cancel</a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
// import pick from 'lodash.pick'
import HotelBasic from './components/HotelBasic'
import HotelDesigner from './components/HotelDesigner'
import HotelPrompt from './components/HotelPrompt'
import FooterToolBar from '@/components/FooterToolbar'

export default {
  name: 'HOTELEdit',
  components: {
    FooterToolBar,
    HotelBasic,
    HotelDesigner,
    HotelPrompt
  },
  props: {
    record: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {
      // 保存状态
      saving: false,
      // 加载中
      loading: true
    }
  },
  mounted () {
    this.initData(this.record)
  },
  methods: {
    async initData (data) {
      this.loading = true
      if (data === '') {
        // 新增
        //formData = { 'id': null, 'code': null, 'nameEnUs': null, 'nameZhTw': null, 'nameZhCn': null, 'cityId': null }
      }
      this.loading = false
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit (e) {
      e.preventDefault()
    }
  }
}
</script>
<style lang="less" scoped>
.basic {
  padding-bottom: 10px;
}
</style>